import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CashDroEvents } from '../../enums/CashDroEvents';
import { SocketEvent } from '../../enums/SocketEvent';
import { TerminalTableRequest, TerminalTableRequestType } from '../../models/TableRequest';

const SOCKET_IO_SERVICE = '/v1/socketio/';

@Injectable({
	providedIn: 'root',
})
export class SmoothrSocketService {
	private socket: Socket;

	constructor() {
		this.socket = io(environment.baseUrl, {
			path: `${SOCKET_IO_SERVICE}socket.io/`,
			autoConnect: false,
		});
	}

	async authenticate(venues: string[]): Promise<void> {
		this.socket.connect();
		return new Promise((resolve, reject) => {
			this.socket.timeout(2_000).emit(SocketEvent.AUTHENTICATE, ['COUNTER_DISPLAY', 'TERMINAL'], venues, (err: any) => {
				console.log(SocketEvent.AUTHENTICATE, ['COUNTER_DISPLAY', 'TERMINAL'], venues, 'done');
				if (err) {
					console.error(err);
					reject(err);
					return;
				}
				resolve();
			});
		});
	}

	onTerminalTableRequest(tables: string[]): Observable<TerminalTableRequestType> {
		this.socket.connect();
		return new Observable<TerminalTableRequestType>(subscriber => {
			const handlers: Map<string, (request: TerminalTableRequestType) => void> = new Map();
			for (const table of tables) {
				const handler = (request: TerminalTableRequestType) => {
					subscriber.next(request);
				};
				const event = `${SocketEvent.TERMINAL_TABLE_REQUEST}_${table}`;
				this.socket.on(event, handler);
				handlers.set(event, handler);
			}

			// Teardown: runs when the subscriber unsubscribes
			return () => {
				handlers.forEach((v, k) => {
					this.socket.off(k, v);
				});
			};
		});
	}
	async emitOnDeinstagMode(table: string): Promise<void> {
		return new Promise<void>((resolve, reject) => {
			this.socket.connect();
			this.socket.emit(SocketEvent.TERMINAL_TABLE_REQUEST, table, TerminalTableRequestType.DEINSTAG_BLOCKED, () => {
				resolve();
			});
		});
	}

	cashDroEvents(orderId: string): Observable<CashDroEvents> {
		this.socket.connect();
		return new Observable<CashDroEvents>(subscriber => {
			const handler = (id: string, event: CashDroEvents) => {
				if (id === orderId) {
					console.log('CashDroEvents', id, event);
					subscriber.next(event);
				}
			};

			this.socket.on('cashDro_status', handler);

			this.socket.emit('listen_cashdro', orderId, () => {
				console.log('CashDroEvents', 'listen_cashdro was called.');
			});

			// Teardown: runs when the subscriber unsubscribes
			return () => {
				this.socket.off('cashDro_status', handler);
			};
		});
	}

	async cancelPayment(orderId: string): Promise<void> {
		return new Promise<void>((resolve, reject) => {
			this.socket.connect();
			this.socket.timeout(2_000).emit('cancel_cashDro', orderId, (err: any) => {
				console.log('cancel_cashDro was called.', err);
				if (err) {
					reject(err);
					return;
				}
				resolve();
			});
		});
	}

	disconnect() {
		if (this.socket) {
			this.socket.disconnect();
		}
	}
}
